import FacetedFiltering from '../components/FacetedFiltering';

export default class StaticSearch {
  constructor(section) {
    this.facetedFilters = new FacetedFiltering(section);
  }

  onSectionUnload() {
    this.facetedFilters.unload();
  }
}
